<template>
  <div :class="`loader-${type}`">
    <div class="loader" />
    <div v-if="text" :class="['loader-text', `loader-text-${type}`]">
      <div :class="['text', `${font}`]">
        <span>{{ text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Componente con estilo loading para utilizarlo en condiciones de espera donde querramos, ejemplo:
 *inicio de la aplicación, dentro de cualquier container. El componente siempre se
 *muestra en el centro tanto vertical como horizontal del container padre.
 */
export default {
  name: 'AldLoader',
  status: 'ready',
  release: '1.1.0',

  props: {
    /**
     * Texto que aparece en el loader, si existe se muestra
     */
    text: { type: String, default: '' },

    /**
     * Cuando pasamos el 'type' como 'inline'
     * el texto pasará a la derecha en tamaños superiores a un movil.
     *
     * @see Opciones: `block | inline`
     */
    type: {
      type: String,
      default: 'block',
      validator: value => value.match(/(block|inline)/)
    },

    /**
     * Modifica el grosor del texto
     *
     * @see Opciones: `normal | medium | bold`
     */
    font: {
      type: String,
      default: 'normal',
      validator: value => value.match(/(normal|medium|bold)/)
    }
  }
};
</script>

<style lang="scss" scoped src="./loader.scss"></style>
